import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import axiosInstance from 'src/utils/axios';

interface DepartmentRequest {
  companyId?: string;
  departmentId: number;
  name: string;
  glCodes: number[];
  members: number[];
}

interface UseUpdateDepartmentMutationOptions {
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

const useUpdateDepartmentMutation = ({
  onSuccess,
  onError,
}: UseUpdateDepartmentMutationOptions = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (params: DepartmentRequest) => {
      const { companyId, departmentId, ...rest } = params;
      const res = await axiosInstance.put<DepartmentRequest[]>(
        api.updateDepartment(departmentId, companyId),
        rest
      );
      return res.data;
    },
    onSuccess: (data, variables) => {
      // Invalidate department list queries to refetch updated data
      if (variables.companyId) {
        queryClient.invalidateQueries({
          queryKey: [...queryKeys.department.departmentList(variables.companyId.toString())],
        });
        // Invalidate clients query to refetch updated data
        queryClient.invalidateQueries({
          queryKey: [...queryKeys.company.clients(variables.companyId.toString())],
        });
      }
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export default useUpdateDepartmentMutation;
